<!--
 * @Description  : 文库首页
 * @Author       : 王帅
 * @Date         : 2024-09-25 11:55:00
 * @LastEditors  : git config user.sname
 * @LastEditTime : 2025-09-25 16:18:19
 * @FilePath     : \ngs_platform_manage_admin\src\views\library-server\library-home.vue
-->
<template>
	<div class="main-container library-home" v-if="!this.$parent.showcenter">
		<section class="card-box" v-for="(item, index) in cardList" :key="item.id" :style="`height: ${activeCardBoxHeight}px`">
			<div class="card-title">
				<span class="card-title-icon">
					<el-image v-if="!!item.logoUrl" :src="item.logoUrl || ''" alt="图标"></el-image>
					{{ item.sname }}
				</span>
				<!-- <svg-icon class="card-title-icon" :icon-class="item.iconClass || 'documentation'"></svg-icon>{{ item.sname }}</span> -->
				<span class="card-title-more" @click="getMore(item)">更多 <i class="el-icon-d-arrow-right"></i></span>
			</div>
			<div class="card-content">
				<section :style="`height: ${activeCardHeight}px;overflow-y: auto;`">
					<!-- 如果没有数据 -->
					<div v-if="item.textFiles.length === 0" class="card-row">暂无数据</div>
					<!-- 如果有数据 -->
					<template v-else>
						<div class="card-row" v-for="(row, rowIndex) in item.textFiles" :key="item.id + rowIndex" @click="getDetail(row, item)">
							<el-tooltip visible="auto" :content="row.title">
								<span class="card-row-title">{{ row.title }}</span>
							</el-tooltip>
							<!-- <span class="card-row-time">{{ row.applyDate }}</span> -->
						</div>
					</template>
				</section>
			</div>
		</section>
	</div>
	<div class="main-container library-list" v-else-if="$parent.pageInfo.showType == 0 && this.$parent.showcenter">
		<div class="w-table-layout">
			<div class="w-table-content">
				<vxe-grid v-bind="gridOptions" ref="xGrid" @checkbox-change="({ row }) => handleTool(row, 'view')">
					<!-- 标题列 -->
					<template #title="{ row }">
						<div class="title">
							<el-tooltip :disabled="row.title.length < 32" :content="row.title">
								<p class="title-name" v-html="highlightText(row.title)"></p>
							</el-tooltip>
						</div>
					</template>

					<!-- 操作列 -->
					<template #tool="{ row }">
						<el-dropdown :show-icon="false" @command="handleCommand($event, row)" v-if="row.isDownload || row.isDownloadAtt">
							<span @click.stop="javascript:;" class="tool-btn">下载</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item command="mainFile" v-if="row.isDownload">正文</el-dropdown-item>
								<el-dropdown-item command="otherFile" v-if="row.isDownloadAtt">附件</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>

						<span class="tool-btn" @click.stop="handleTool(row, 'view')">查看</span>
					</template>
				</vxe-grid>
			</div>
		</div>
	</div>
</template>

<script>
import * as Api from '@/api/modules/library-server/index.js'
import { exportPlus } from 'utils/tools'
export default {
	name: '',
	data() {
		return {
			cardList_mock: [],
			// 表格配置
			gridOptions: {
				...this.$gridOption1(this.getPageData),
				toolbarConfig: {
					enabled: false
				},
				border: 'none',
				height: 'auto',
				minHeight: 920,
				columnConfig: { resizable: false },
				checkboxConfig: { trigger: 'row' },
				columns: [
					{
						field: '',
						type: 'checkbox',
						align: 'left',
						minWidth: 170,
						visible: false
					},
					{
						field: 'title',
						title: '标题',
						align: 'left',
						width: 300,
						minWidth: 300,
						slots: {
							default: 'title'
						}
					},
					{
						field: 'issueUnit',
						title: '颁布机关',
						align: 'left',
						width: 235,
						minWidth: 235
					},
					{
						field: 'lawRankName',
						title: '法律性质',
						align: 'left',
						width: 120
					},
					{
						field: 'referNo',
						title: '文号',
						align: 'left',
						width: 300,
						minWidth: 300
					},
					{
						field: 'efficientName',
						title: '时效性',
						align: 'left',
						width: 120
					},
					{
						field: 'tool',
						title: '操作',
						align: 'left',
						minWidth: 120,
						slots: {
							default: 'tool'
						}
					}
				]
			},
			// 请求参数
			queryObj: {
				alias: '', // 招采文库 暂时写死
				id: '', // 分类ID
				title: '', // 标题
				rangeType: '0', //检索范围 0-标题，1-正文，2-标题+正文
				fuzzySearch: '1', //检索方式 1-模糊，0-精确
				issuesUnit: '', // 颁布机关
				referNo: '', // 文号
				efficient: '', // 时效性
				lawRank: '', // 法律效力位阶
				applyDate: [], // 施行日期数组
				applyStart: '', // 施行日期开始
				applyEnd: '', // 施行日期结束
				releaseDate: [], // 公示日期数组
				releaseStart: '', // 公示日期开始
				releaseEnd: '' // 公示日期结束
			}
		}
	},
	methods: {
		// 初始渲染(模拟)
		initData() {
			let mockData = [
				{
					id: '1',
					sname: '法律',
					sort: 1,
					defaultNum: 5,
					textFiles: [
						{
							fileName: '中华人民共和国合同法',
							sort: 1,
							applyDate: '2022-06-17'
						},
						{
							fileName: '中华人民共和国合同法',
							sort: 2,
							applyDate: '2022-06-17'
						},
						{
							fileName: '中华人民共和国合同法',
							sort: 3,
							applyDate: '2022-06-17'
						},
						{
							fileName: '中华人民共和国合同法',
							sort: 4,
							applyDate: '2022-06-17'
						},
						{
							fileName: '中华人民共和国合同法',
							sort: 5,
							applyDate: '2022-06-17'
						}
					]
				},
				{
					id: '2',
					sname: '行政法规',
					sort: 2,
					defaultNum: 5,
					textFiles: [
						{
							fileName: '安徽省建设工程计价依据动态调整',
							sort: 1,
							applyDate: '2022-06-17'
						},
						{
							fileName: '安徽省建设工程计价依据动态调整',
							sort: 2,
							applyDate: '2022-06-17'
						},
						{
							fileName: '安徽省建设工程计价依据动态调整',
							sort: 3,
							applyDate: '2022-06-17'
						},
						{
							fileName: '安徽省建设工程计价依据动态调整',
							sort: 4,
							applyDate: '2022-06-17'
						},
						{
							fileName: '安徽省建设工程计价依据动态调整',
							sort: 5,
							applyDate: '2022-06-17'
						}
					]
				},
				{
					id: '3',
					sname: '省政府规章及规范性文件',
					sort: 3,
					defaultNum: 5,
					textFiles: [
						{
							fileName: '安徽省建筑工程招标投标管理办法',
							sort: 1,
							applyDate: '2022-06-17'
						},
						{
							fileName: '安徽省建筑工程招标投标管理办法',
							sort: 2,
							applyDate: '2022-06-17'
						},
						{
							fileName: '安徽省建筑工程招标投标管理办法',
							sort: 3,
							applyDate: '2022-06-17'
						}
						// {
						// 	fileName: '安徽省建筑工程招标投标管理办法',
						// 	sort: 4,
						// 	applyDate: '2022-06-17'
						// },
						// {
						// 	fileName: '安徽省建筑工程招标投标管理办法',
						// 	sort: 5,
						// 	applyDate: '2022-06-17'
						// }
					]
				},
				{
					id: '4',
					sname: '财政部规章及规范性文件',
					sort: 4,
					defaultNum: 5,
					textFiles: []
				}
			]
			this.cardList_mock = mockData
		},

		// 打开详情页
		getDetail(row, item) {
			let url = `${window.location.origin}${window.location.pathname}#/library-server/detail?detailName=${row.title}&detailId=${row.id}`
			bmStorage.sessionStorage.set('libraryDetailPage', JSON.stringify({ detailName: row.title, detailId: row.id }))
			window.open(url, '_blank')
		},

		// 获取更多
		getMore(item) {
			// 存储信息
			let params = {
				parentName: '',
				parentId: '', //
				sname: item.sname,
				id: item.id
			}
			// 找到id 对应tab 的id
			let Object = this.$parent.selectTypes.find((x) => x.id == this.$parent.queryObj.typeId)
			if (Object) {
				params.parentName = Object.sname
				params.parentId = Object.id
			}
			bmStorage.sessionStorage.set('libraryListPage', JSON.stringify(params))

			this.$parent.queryObj.id = item.id
			this.$router.push({
				name: 'libraryList',
				query: {
					sname: item.sname,
					parentName: Object.sname,
					parentId: Object.id,
					id: item.id
				}
			})
		},
		// 其它页面调用查询
		doSearch() {
			// 找到组件内 页码切换掉
			this.$refs.xGrid.tablePage.currentPage = 1
			this.$refs.xGrid.tablePage.pageSize = 10
			this.$refs.xGrid.commitProxy('query')
		},

		// 异步抓取数据
		async getPageData({ page, sorts, filters }) {
			this.gridOptions.loading = true
			let current = page.currentPage
			let size = page.pageSize

			let params = {
				current,
				size
			}

			// 实施接口测试参数
			params = {
				current,
				size,
				...this.$parent.queryObj
			}

			params.alias = this.alias

			params.id = this.libraryListPage.id
			const route = this.$route
			const query = route.query
			if (query.parentId && query.parentName) {
				params.id = this.$route.query.id
			}
			params.typeId = ''

			const result = await Api.zcClassifyPage(params).catch((err) => {})

			setTimeout(() => {
				this.gridOptions.loading = false
			}, 500)

			let exist = result && result.data.page
			// 更新页码
			this.gridOptions.pagerConfig.currentPage = exist ? result.data.current : current
			this.gridOptions.pagerConfig.pageSize = exist ? result.data.size : size

			// 更新 底部记录
			this.$nextTick(() => {
				if (this.$parent) {
					this.$parent.pageFooter.accessTimes = result.data.accessTimes || 0
					this.$parent.pageFooter.downloadTimes = result.data.downloadTimes || 0
					this.$parent.selectTypes = result.data.selectTypes || []
					this.$parent.pageInfo.title = result.data.title || ''
					this.$parent.pageInfo.homeLogo = result.data.homeLogo || ''
					// 是平铺才显示
					if (this.$parent.pageInfo.showType != 1) {
						this.$parent.selectTypes.splice(0, 0, {
							id: '1', //
							sname: '首页'
						})
					}
				}
			})

			return {
				result: exist ? result.data.page.records : [],
				page: {
					total: exist ? result.data.page.total : 0
				}
			}
		},

		// 下载下拉
		handleCommand(type, row) {
			this.handleTool(row, type)
		},
		// 操作按钮
		handleTool(row, type) {
			switch (type) {
				case 'view':
					// 跳转页面
					let url = `${window.location.origin}${window.location.pathname}#/library-server/detail?detailName=${row.title}&detailId=${row.id}`
					bmStorage.sessionStorage.set('libraryDetailPage', JSON.stringify({ detailName: row.title, detailId: row.id }))
					window.open(url, '_blank')
					break
				case 'mainFile':
					// 下载正文，保存记录
					let params = {
						alias: 'zcwk', // 招采文库 暂时写死
						fileId: row.id,
						type: 1 // 1 下载 ，0阅读
					}
					Api.saveRead(params).then((res) => {
						this.$downloadFile(row.fileUrl, row.fileName)
					})
					break
				case 'otherFile':
					// 下载附件
					let params2 = {
						manageId: row.id, //this.$route.query.id,
						attachmentId: []
					}

					exportPlus('/docManage/downloadAttachment', params2, '', '', '下载完成！')
					break
			}
		},
		// 检索高亮
		highlightText(text, keyword = null) {
			keyword = keyword || this.$parent.queryObj.title
			// 'gi' 标志表示全局搜索并且不区分大小写
			const regex = new RegExp(`(${keyword})`, 'gi')
			//匹配出相关的结果
			text = text.replace(regex, '<span class="highlight-text">$1</span>')

			return text
		}
	},
	created() {
		// 清空sessionstorage
		bmStorage.sessionStorage.remove('libraryListPage')
		bmStorage.sessionStorage.remove('libraryDetailPage')
	},
	computed: {
		// 缓存信息 --- 列表页信息
		libraryListPage() {
			return bmStorage.sessionStorage.get('libraryListPage') ? JSON.parse(bmStorage.sessionStorage.get('libraryListPage')) : {}
		},

		// 请求参数的alias
		alias() {
			return this.$route.query.alias || bmStorage.sessionStorage.get('alias') || 'xhwk'
		},
		// 取父元素的数据
		cardList() {
			return this.$parent ? this.$parent.showTypes : []
		},
		// 最大展示条数
		showNum() {
			return this.$parent ? this.$parent.pageInfo.showNum : 5
		},
		// 动态行高
		activeCardHeight() {
			let rowHeight = 50
			if (this.cardList.length === 0) {
				return rowHeight
			}
			return rowHeight * this.showNum
		},
		// 动态行高
		activeCardBoxHeight() {
			let rowHeight = 50
			if (this.cardList.length === 0) {
				return rowHeight + 60
			}
			return rowHeight * this.showNum + 60
		}
	},
	watch: {
		'$parent.showcenter': {
			handler: function(obj) {
				if (this.$refs.xGrid) {
					this.doSearch()
				}
			},
			deep: true,
			immediate: true
		}
	}
}
</script>
<style scoped lang="less">
.w-table-layout {
	background-color: transparent !important;
}
</style>
